import React, { Component } from 'react'


import { Link } from 'react-router-dom';
import PlusIcon from '../../icons/plusicon';

import SearchIcon from '../../icons/searchicon';

import service from "../../services";

import moment from "moment-timezone";

import _ from 'lodash'
//Redux Connect
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { ActCreators } from "../../redux/bindActionCretor";
import CheckBox from '../CheckBox';

import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';

import SimpleReactValidator from 'simple-react-validator';


let sub;

// fake data generator
const getItems = (count) =>
    Array.from({ length: count }, (v, k) => k).map((k) => ({
        id: `item-${k}`,
        content: `item ${k}`,
    }));

// a little function to help us with reordering the result
const reorder = (list, startIndex, endIndex) => {
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);

    return result;
};

const mapStateToProps = (state) => ({
    notificationId: state.notificationId
});

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators(ActCreators, dispatch);
};

class MobileCreate extends Component {
    constructor(props) {
        super(props)

        this.state = {

            notificationText: '',
            films: [],
            ErrorMsg: false,
            SynopsisLength: 0,
            searchField: '',
            emails: [],
            copyEmail: [],
            shortProgrammeFilms: [],
            EmailListInside: [],
            notificationId: this.props.notificationId,




        }
        this.apiserve = new service();
        this.validator = new SimpleReactValidator();
    }




    componentWillUnmount = () => {
        sub.unsubscribe();
    };

    componentDidMount = () => {
        this.getDetails();
        // if (this.state.notificationId) {
        //     this.apiserve.sendevent("admin|viewNoty", {
        //       notificationId: this.state.notificationId
        //     });
        //   }

        this.apiserve.sendevent("admin|lastNotyUpdate",{});
        sub = this.apiserve.getevent().subscribe((response) => {
            switch (response.event) {
                case "admin|saveNoty":

                    if (!response.error) {
                        this.setState({

                            notificationText: response.data.notificationText,
                            emails: response.data.emails,

                        })
                        this.props.history.push("/mobile-app")
                    }
                    break;
                case "admin|viewNoty":

                    if (!response.error) {
                        this.state.copyEmail = response.data.docs[0].emails.map((item) => {
                            let obj = {}
                            obj["email"] = item
                            obj["isCheck"] = false
                            return obj
                        })

                        this.setState({
                            notificationText: response.data.docs[0].notificationText,
                            emails: this.state.copyEmail.filter(e => e.email != null)
                        })

                    }
                    break;
                case "admin|lastNotyUpdate":
                    this.setState({
                        getLastUpdated: response.data[0],
                    })
                    break;
                // case "fpg|shortProgramme|P":
                //     if (response.error) {
                //         this.setState({
                //             errorPopup: true,
                //             errorMsg: response.data.error ? response.data.error : response.data
                //         })
                //     } else {
                //         this.apiserve.success('Updated successfully.')
                //         this.props.history.push('/short-program-list')
                //     }
                //     break;



                default:
                    break;
            }
        });
    };


    getDetails = () => {

        const data = {
            emails: [],
            notificationText: "",
            notificationId: this.props.notificationId,
        }
        this.apiserve.sendevent("admin|saveNoty", data);
    };

    onInputChange = (e) => {
        this.setState({
            [e.target.name]: e.target.value
        });
    }






    //Search Data


    getMtTime = (date) => {
        //Get offset from mountain time using UTC
        let ABBR = moment.tz("America/Denver").format("z");
        let offDifference = moment().utcOffset() + (ABBR === 'MDT' ? 360 : 420);

        // add that offset in date
        return moment(date).add(offDifference, 'minutes').toISOString()
    }






    clearAllForm = () => {
        this.setState({
            // notificationText: "",
            // emails: [],
        })
        this.props.NotificationEditData('')
    }

    cancleMobileApp = (e) => {
        e.preventDefault();
        // window.location.reload();
        // this.props.history.push({
        //     pathname: '/mobile-app'
        // })
    }

    //upload CSV
    uploadCSV = (e) => {
        const file = e.target.files[0];
        const reader = new FileReader();
        var self = this;
        reader.onload = function (e) {
            const text = e.target.result;
            self.processCSV(text)
        }
        reader.readAsText(file);
    }

    processCSV = (str, delim = '\r') => {
        try {
            const headers = str.slice(0, str.indexOf('\n')).split(delim);
            var rows = str.slice(str.indexOf('\n') + 1).split('\n');
            // if(rows.length!==1){
            //     rows.splice(-1)
            // }
            rows = rows.filter(item => item);
            const newArray = rows.map((row,i) => {           
                const values = row.split(delim);
                const eachObject = headers.reduce((obj, header, i) => {
                    obj[header] = values[i];
                    return obj;
                }, {})
                return eachObject;
            })
            let FilmTypeFilterData = newArray.map((item, i) => {
                return ({
                    'email': item.email,
                    isCheck: false
                })
            })

            FilmTypeFilterData = [...new Map(FilmTypeFilterData.map(item => [item.email, item])).values()];


            FilmTypeFilterData = [...FilmTypeFilterData, ...this.state.copyEmail]

            const filteredArr = FilmTypeFilterData.reduce((acc, current) => {
                const x = acc.find(item => item.email === current.email);
                if (!x && current.email != null) {
                    return acc.concat([current]);
                } else {
                    return acc;
                }
            }, []);
            var key, count = 0;
  
            // Check if every key has its own property
            for (key in filteredArr) {
                if (filteredArr.hasOwnProperty(key))
                 count++;
            }
           this.setState({filteredArr:count})
            this.state.EmailListInside = filteredArr
            this.setState({ emails: filteredArr, copyEmail: filteredArr })
        } catch (error) {

        }
    }
    removeCSV = (e) => {
        let FilterEmailData = this.state.emails.filter(e => e.isCheck == false)
        this.state.copyEmail = FilterEmailData;
        this.setState({ emails: FilterEmailData })
        const filteredArr = FilterEmailData.reduce((acc, current) => {
            const x = acc.find(item => item.email === current.email);
            if (!x && current.email != null) {
                return acc.concat([current]);
            } else {
                return acc;
            }
        }, []);
        var key, count = 0;
  
        // Check if every key has its own property
        for (key in filteredArr) {
            if (filteredArr.hasOwnProperty(key))
             count++;
        }
       this.setState({filteredArr:count})
        var filteredShortProgram = this.state.EmailListInside.filter(_ => _.email !== _.email)
            this.setState({
                EmailListInside: filteredShortProgram
            });
    }
  onSearchFilter = (e) => {
        this.setState({
            searchField: e.target.value,
        }, () => {

            let emaildata = JSON.parse(JSON.stringify(this.state.copyEmail))
            if (this.state.searchField !== "") {

                let eData = this.state.emails
                eData = eData.filter((contact) => {
                    return Object.values(contact)
                        .join(" ")
                        .toLowerCase()
                        .includes(this.state.searchField.toLowerCase())
                })

                this.setState({ emails: eData })
            }
            else {
                const emails = this.state.EmailListInside.filter(e => e.isCheck == true).map(user => user.email);
                let FilterEmailData = emaildata.map((item, i) => {
                    return ({
                        'email': item.email,
                        'isCheck': emails.indexOf(item.email) != -1 ? true : false,
                    })
                })

                FilterEmailData = [...new Map(FilterEmailData.map(item => [item.email, item])).values()];
                this.setState({ emails: FilterEmailData })
                this.forceUpdate()
            }
        })
    }
    mobileCheck = (e, item, i) => {
     const { name, checked } = e.target
        let chkarray = [...this.state.EmailListInside, item]

        if (checked) {
            this.state.emails[i].isCheck = true
            this.setState({
                EmailListInside: chkarray
            })
            this.forceUpdate();

        } else {
            this.state.emails[i].isCheck = false
            var filteredShortProgram = this.state.EmailListInside.filter(_ => _.email !== item.email)
            this.setState({
                EmailListInside: filteredShortProgram
            });
        }
    }
   
    submitMobileNotification = (e) => {
        e.preventDefault()
        if(this.state.SynopsisLength < 140 ){
            var newProgram = this.state.copyEmail
            var shortProgrammeFilms = this.state.shortProgrammeFilms;
            for (let i = 0; i < newProgram.length; i++) {
    
                // var films = {
                //     film: newProgram[i].email
                // };
                shortProgrammeFilms.push(newProgram[i].email);
                // if (newProgram.length === 1 + i) {
                //     this.setState({
                //         shortProgrammeFilms: shortProgrammeFilms,
    
                //     })
                // }else{
    
                // }
            }
            // const data = {
            //     emails:shortProgrammeFilms, notificationText:this.state.notificationText
            //   }
            // return data;
    
            this.apiserve.sendevent("admin|saveNoty", { emails: shortProgrammeFilms, notificationText: this.state.notificationText, notificationId: this.state.notificationId });
        }
        else{
            console.log("error");
        }
       
    }
    screeningChange = (e) => {
        const { name, value } = e.target
        if (name === 'notificationText') {
            let len = value
            // len = len.filter(_ => _ !== '');
            if (len.length <= 140) {
                this.setState({
                    // ...this.state,
                    [name]: value
                }
                )
                this.setState({ SynopsisLength: len.length })
                this.forceUpdate()
            } else {

            }
        }
    }

    render() {
        const { ShortProgramList, dropList, film, shortProgrammeFilms, emails, newData, getLastUpdated } = this.state
        var updateAt = new Date(getLastUpdated && getLastUpdated.updatedAt)
          var hour = moment(updateAt).format('h')
        var minutes = moment(updateAt).format('mm')
        var state = moment(updateAt).format('A')
        var updatedBy = getLastUpdated && getLastUpdated.updatedBy
        return (
            <React.Fragment>
                {/* <MainLayout history={this.props.history}> */}
                <div className="right_side_wrapper relative">
                    {/* {this.state.shortPopUp ?  <span className="popup_overlay" onClick={() => this.HideShortPopUp}> </span> :''} */}
                    <div className="bradcrumb disp_flex d_flex_justify_spacebt d_flex_align_center">
                        <ul className="disp_flex">
                            <li> Add / Edit Mobile Notification</li>
                        </ul>
                        <Link className="add_page" onClick={(e) => this.clearAllForm(e)}><PlusIcon /></Link>
                    </div>
                    <div className="back_date d_flex d_flex_align_center d_flex_justify_spacebt">
                        <Link className="back_link" to='/mobile-app'> <svg width="5" height="10" viewBox="0 0 5 10" fill="none"> <path d="M5 0L0 5L5 10V0Z" fill="black" /> </svg> Back To List</Link>
                        {this.state.getLastUpdated && this.state.getLastUpdated.updatedAt === undefined ? '' :
                            <p className="update_date">Last Update: {hour}:{minutes} {state} - {moment(updateAt).format('MM/DD/YYYY')}</p>
                        }
                    </div>
                    <div className="program_main fpg_tabcontent ">
                        <form onSubmit={(e)=>e.preventDefault()}>
                            <div className="d_flex">
                                <div className="program_left mt_0">
                                    <div className="program_title_input send_to_email_input mb_10">
                                        <div className="field_row horizontal_field">
                                            <div className="disp_flex ">
                                                <label>Notification Text </label>
                                                <textarea style={{ height: '100px', borderRadius: '5px', resize: 'none' }}
                                                    onChange={this.screeningChange}
                                                    name="notificationText" id="notificationText"
                                                    value={this.state.notificationText} ></textarea>
                                            </div>
                                            <div className="disp_flex ">
                                                <label></label> <span style={{ color: 'red' }}>{this.state.SynopsisLength >= 140 ? 'Maxiumum 140 characters.' : ""}</span>
                                            </div>
                                            {/* <p className='text_right mr_10'> {this.state.SynopsisLength}</p> */}
                                            {/* <span style={{ color: 'red' }}>{this.validator.message('notificationText', this.state.notificationText, 'required')}</span> */}
                                        </div>
                                        <div className="field_row horizontal_field">
                                            <div className="disp_flex ">
                                                <label>Send To</label>
                                                <div className="program_popup">
                                                    <p class="form_note">Add User by Email</p>
                                                    <div className="program_popup_header d_flex d_flex_justify_spacebt d_flex_align_center">
                                                        <span className="header_title">Select Emails</span>
                                                        <div className="relative field_row mb_0">
                                                            <div className="field_input">
                                                                <input
                                                                    type="text"
                                                                    placeholder="Search"
                                                                    id="searchField"
                                                                    name="searchField"
                                                                    value={this.state.searchField}
                                                                    onkeypress="return e.keyCode != 13"
                                                                    onChange={(e)=>this.onSearchFilter(e)} />
                                                                <span className="pointer search_icon" style={{ pointerEvents: 'none' }}><SearchIcon /></span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="popup_content" style={{ height: '300px', overflowY: "auto", background: "#fff", marginLeft: "10px", marginRight: "10px", marginBottom: "10px", marginTop: "10px" }}>
                                                        {emails?.length > 0 && emails?.map((item, i) => {
                                                            return (
                                                                <>
                                                                    <div className="customCheckBox">
                                                                        <CheckBox name='selectShortFilm'
                                                                           value={item.email}
                                                                            onChange={(e) => this.mobileCheck(e, item, i)}
                                                                            label={item.email}
                                                                            checked={item.isCheck === true ? true : false}
                                                                            type="checkbox"
                                                                            id={item.email}
                                                                        />

                                                                    </div>
                                                                </>
                                                            )

                                                        })}
                                                  </div>
                                                    <div className="disp_flex d_flex_align_center invitee_btns">
                                                        <span className="relative pointer">
                                                            <input type="file" name="file" accept=".csv" onChange={(e) => this.uploadCSV(e)} />
                                                            Upload <br />CSV
                                                        </span>
                                                        <div className="removebtn"><button className=""  type="button" onClick={(e) => this.removeCSV(e)}>Remove <br /> Selected Users</button></div>
                                                        {/* <span className="upload_csv_invitee relative pointer">
                                                        <input type="button" onChange={(e) => this.removeCSV(e)} />
                                                            Remove <br /> Selected Users
                                                        </span> */}
                                                    </div>
                                                   <div className="disp_flex " style={{marginLeft:"10px"}}>
                                                  <span style={{ color: '#00B412' }}>{this.state.filteredArr === undefined || this.state.filteredArr === 0  ?"" :this.state.filteredArr + "users added."}</span>
                                            </div>
                                                </div>
                                            </div>
                                          
                                            {/* <p className='text_right mr_10'> {this.state.SynopsisLength}</p> */}
                                            {/* <span style={{ color: 'red' }}>{this.validator.message('notificationText', this.state.notificationText, 'required')}</span> */}


                                        </div>

                                    </div>

                                    {/*                                
                                    <div className="program_header d_flex">
                                        <h3>Shorts Included in Program</h3>
                                        <span onClick={this.AddShort}>Add Short + </span>
                                    </div> */}

                                </div>

                                <div className="text_center field_row w_100 buttons_outer mb_0">
                                    <button className="uppercase" type='button' onClick={(e) => this.cancleMobileApp(e)}>CANCEL</button>
                                    <button className="uppercase active" type='button' onClick={(e) => this.submitMobileNotification(e)}>SAVE</button>
                                </div>
                            </div>
                        </form>
                    </div>


                </div>


                {/* </MainLayout> */}
            </React.Fragment>
        )
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(MobileCreate);